import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'reports',
	loader: () => ({
		meta: {
			title: 'Reports',
			disabled: true,
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/propertyDocument/reports/Layout')).default }),
	children: [
		{
			path: 'pnl',
			index: true,
			id: 'propertyDocumentPnlReport',
			loader: () => ({
				meta: {
					title: 'Profit and Loss',
					htmlTitle: 'Property Document Profit and Loss Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/reports/pages/PnL')).default }),
		},
		{
			path: 'mailing',
			index: true,
			id: 'propertyDocumentMailingReport',
			loader: () => ({
				meta: {
					title: 'Mailings',
					htmlTitle: 'Property Document Mailing Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/reports/pages/Mailing')).default }),
		},
		{
			path: 'order',
			index: true,
			id: 'propertyDocumentOrderReport',
			loader: () => ({
				meta: {
					title: 'Order',
					htmlTitle: 'Property Document Order Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/reports/pages/Order')).default }),
		},
		{
			path: 'order/date',
			index: true,
			id: 'propertyDocumentOrderByDateReport',
			loader: () => ({
				meta: {
					title: 'Order By Date',
					htmlTitle: 'Property Document Order By Date Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/reports/pages/OrderByDate')).default }),
		},
	],
};
export default route;
